<table>
  <thead>
    <tr>
      <th><opac-skeleton style="width: 40px; height: 14px"></opac-skeleton></th>
      <th><opac-skeleton style="width: 40px; height: 14px"></opac-skeleton></th>
      <th><opac-skeleton style="width: 40px; height: 14px"></opac-skeleton></th>
      <th><opac-skeleton style="width: 40px; height: 14px"></opac-skeleton></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let i of [1, 2, 3, 4]">
      <td><opac-skeleton style="width: 100px; height: 14px"></opac-skeleton></td>
      <td><opac-skeleton style="width: 30px; height: 14px"></opac-skeleton></td>
      <td><opac-skeleton style="width: 30px; height: 14px"></opac-skeleton></td>
      <td><opac-skeleton style="width: 30px; height: 14px"></opac-skeleton></td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td><opac-skeleton style="width: 40px; height: 14px"></opac-skeleton></td>
      <td><opac-skeleton style="width: 30px; height: 14px"></opac-skeleton></td>
    </tr>
  </tfoot>
</table>
